// extracted by mini-css-extract-plugin
module.exports = {"box":"CheckBoxFormik_box__efb7Z","custom_checkbox":"CheckBoxFormik_custom_checkbox__3XuZ_"};